module.exports = __webpack_public_path__ + "static/media/photo1.9294e03d.jpg";